export const ZENDESK_HELP_URL =
  "https://support.manifold.ai/hc/en-us/articles/43511727336461-Getting-Started-with-AI";
